// extracted by mini-css-extract-plugin
export default {"workspace_wrapper":"page_workspace_wrapper__PKu0N"};